module.exports = __webpack_public_path__ + "static/media/alpha_11.0d9c99ed.png";